// extracted by mini-css-extract-plugin
export default {"cls1":"Spinner-cls1_IXt","cls2":"Spinner-cls2_yGm Spinner-cls1_IXt","spin":"Spinner-spin_MNf","blue":"Spinner-blue_FTm"};